import { gql, useMutation } from '@apollo/client'
import {
  MutationVehicleStatusChangeArgs,
  MutationVehicleStatusChangePayload,
} from 'src/generated'

const MUTATION_VEHICLE_STATUS_CHANGE = gql`
  mutation VehicleStatusChange($input: MutationVehicleStatusChangeInput!) {
    vehicleStatusChange(input: $input) {
      isDisabled
    }
  }
`

const useVehicleStatusChangeMutation = () => {
  return useMutation<
    { vehicleStatusChange: MutationVehicleStatusChangePayload },
    MutationVehicleStatusChangeArgs
  >(MUTATION_VEHICLE_STATUS_CHANGE)
}

export default useVehicleStatusChangeMutation
